import { useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";

import { getLabel } from "../../tools/Dictionary";
import { getAuth, resetAuth } from "../../slices/authSlice";
import AlertModal from "../Commons/AlertModal";
import authApi from "../../api/authApi";
import languageApi from "../../api/languageApi";
import Global from "../../Global/Global";
import useMount from "../../hooks/useMount";

import { getLanguages } from "../../slices/languageSlice";

const AuthFill = (props) => {


  //Navigation
  const Navigate = useNavigate();

  //Redux
  const Auth = useSelector(getAuth);
  const Dispatch = useDispatch();
  const Language = useSelector(getLanguages);

  //State
  const [error, setError] = useState({});
  const [form, setForm] = useState({
    firstName: (Auth.User && Auth.User.firstName) ? Auth.User.firstName : "",
    lastName: (Auth.User && Auth.User.lastName) ? Auth.User.lastName : "",
    companyName: "",
    language: "",
    temperatureUnit: ""

  });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  //Var
  const component = "AuthFill";
  const TemperatureUnit = [
    { code: "C", name: "Celsius" },
    { code: "F", name: "Fahrenheit" }
  ]

  useMount(() => {

    loadData();

  }, []);

  const loadData = async() => {

    let response = await languageApi.getLanguage();

    console.log(response);
  };
  
  const onChangeFirstName = (e) => {

    let firstName = e.target.value;

    if (firstName.length > 60) return;

    onValidateField("firstName", firstName);

    setForm(form => ({
      ...form,
      firstName
    }));
  };

  const onChangeLastName = (e) =>
  {

    let lastName = e.target.value;

    if (lastName.length > 60) return;

    onValidateField("lastName", lastName);

    setForm(form => ({
      ...form,
      lastName
    }));

  };

  const onChangeCompanyName = (e) =>
  {

    let companyName = e.target.value;

    if (companyName.length > 100) return;

    onValidateField("companyName", companyName);

    setForm(form => ({
      ...form,
      companyName
    }));

  };


  const onChangeLanguageCode = (e) =>
  {

    let language = e.target.value;

    onValidateField("language", language);

    setForm(form => ({
      ...form,
      language
    }));

  };

  const onChangeTemperatureUnit = (e) =>
  {

    let temperatureUnit = e.target.value;

    onValidateField("temperatureUnit", temperatureUnit);

    setForm(form => ({
      ...form,
      temperatureUnit
    }));

  };

  //Validate field 
  const onValidateField = (field = "", value = "") =>
  {

    let currentError = { ...error };
    let currentField = "";

    //Validate first name
    currentField = "firstName";
    if (field === "" || field === currentField)
    {
      //If value is sent, otherwrise take from form state
      currentError[currentField] = "";
      const currentValue = field === "" ? form[currentField] : value;

      // Set an error message if the field is empty or falsy
      if (currentValue == "" || !currentValue)
        currentError[currentField] = "This field can't be empty."
      
    }

    //Validate last name
    currentField = "lastName";
    if (field === "" || field === currentField)
    {
      //If value is sent, otherwrise take from form state
      currentError[currentField] = "";
      const currentValue = field === "" ? form[currentField] : value;

      // Set an error message if the field is empty or falsy
      if (currentValue == "" || !currentValue)
        currentError[currentField] = "This field can't be empty."
      
    }

    //Validate company name
    currentField = "companyName";
    if (field === "" || field === currentField)
    {
      //If value is sent, otherwrise take from form state
      currentError[currentField] = "";
      const currentValue = field === "" ? form[currentField] : value;

      // Set an error message if the field is empty or falsy
      if (currentValue == "" || !currentValue)
        currentError[currentField] = "This field can't be empty."
      
    }

    //Validate company name
    currentField = "language";
    if (field === "" || field === currentField)
    {
      //If value is sent, otherwrise take from form state
      currentError[currentField] = "";
      const currentValue = field === "" ? form[currentField] : value;

      // Set an error message if the field is empty or falsy
      if (currentValue == "" || !currentValue)
        currentError[currentField] = "This field can't be empty."

    }


    //Validate company name
    currentField = "temperatureUnit";
    if (field === "" || field === currentField)
    {
      //If value is sent, otherwrise take from form state
      currentError[currentField] = "";
      const currentValue = field === "" ? form[currentField] : value;

      // Set an error message if the field is empty or falsy
      if (currentValue == "" || !currentValue)
        currentError[currentField] = "This field can't be empty."

    }



    setError(currentError);

    let valid = true;

    for (let key in currentError)
    {
      if (currentError.hasOwnProperty(key))
      {
        if (currentError[key] !== "")
          valid = false;
      }
    }



    return valid;

  };

  const onClickSubmit = async() => {

    if (!onValidateField()){
      setAlert({
        Title: getLabel("App", "Error"),
        Message: getLabel("App", "The form contains errors. Please check and fix the fields highlighted in red."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });
      return;
    }

    try{

      setLoading(true);

      let response = await authApi.fillAuth(form);

      if (response.Error){
        setAlert({
          Title: getLabel("App", "Error"),
          Message: getLabel(response.Error.component, response.Error.label) || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
          Confirm: getLabel("App", "Ok"),
          onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
          Display: true
        });

        setLoading(false);

        return;

      }

      setLoading(false);

      Navigate("/auth");

    }catch(err){      

      setLoading(false);


      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });
    }

  };

  const onClickCancel = () => {

    localStorage.setItem(Global.apiToken, "");
    localStorage.setItem(Global.apiTokenAI, "");

    Dispatch(resetAuth());

    Navigate("/auth");

  };

 
  return (
    <div className="auth_page_cont">
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <div className="auth_fill_cont">
        <div className="auth_cont_title">
          {getLabel(component, "Complete the information")}
        </div>
        <div className="auth_fill_title">
          {getLabel(component, "To complete your account creation, kindly fill out the form below.")}
        </div>
        <div className="auth_fill_row">
          <input
            className={"form-control auth_cont_login_input " + (error["firstName"] ? "auth_fill_row_input_error" : "")}
            type="text"
            placeholder={getLabel(component, "First name")}
            value={form.firstName}
            onChange={onChangeFirstName}
            disabled={loading}
          />
          {error["firstName"] &&
            <div className="auth_signup_row_error">
              {getLabel(component, error["firstName"])}
            </div>
          }
        </div>
        <div className="auth_fill_row">
          <input
            className={"form-control auth_cont_login_input " + (error["lastName"] ? "auth_fill_row_input_error" : "")}
            type="text"
            placeholder={getLabel(component, "Last name")}
            value={form.lastName}
            onChange={onChangeLastName}
            disabled={loading}
          />
          {error["lastName"] &&
            <div className="auth_signup_row_error">
              {getLabel(component, error["lastName"])}
            </div>
          }
        </div>
        <div className="auth_fill_row">
          <input
            className={"form-control auth_cont_login_input " + (error["companyName"] ? "auth_fill_row_input_error" : "")}
            type="text"
            placeholder={getLabel(component, "Company name")}
            value={form.companyName}
            onChange={onChangeCompanyName}
            disabled={loading}
          />
          {error["companyName"] &&
            <div className="auth_signup_row_error">
              {getLabel(component, error["companyName"])}
            </div>
          }
        </div>
        <div className="auth_fill_row">
          <select
            value={form.language}
            className={"page_select_input auth_cont_login_input " + (error["language"] ? "auth_fill_row_input_error " : "")}
            onChange={onChangeLanguageCode}
            style={{ width: "90%", textAlign: "center", color: (form.language == "" ? "grey" : "black"), fontWeight: "bold", marginTop: "10px" }}
            disabled={loading}
          >
            <option value="" hidden style={{ textAlign: "center" }}>{getLabel("App", "Language")}</option>
            {Language.map((l, index) => (
              <option key={index} value={l.code} style={{ textAlign: "center", color: "black", fontWeight: "bold" }}>
                {l.name}
              </option>
            ))}
          </select>
          {error["language"] &&
            <div className="auth_fill_row_error">
              {getLabel(component, error["language"])}
            </div>
          }
        </div>
        <div className="auth_fill_row">
          <select
            value={form.temperatureUnit}
            className={"page_select_input auth_cont_login_input " + (error["temperatureUnit"] ? "auth_fill_row_input_error " : "")}
            onChange={onChangeTemperatureUnit}
            style={{ width: "90%", textAlign: "center", color: (form.temperatureUnit == "" ? "grey" : "black"), fontWeight: "bold", marginTop: "10px" }}
            disabled={loading}
          >
            <option value="" hidden style={{ textAlign: "center" }}>{getLabel("AuthFill", "Temperature Unit")}</option>
            {TemperatureUnit.map((t, index) => (
              <option key={index} value={t.code} style={{ textAlign: "center", color: "black", fontWeight: "bold" }}>
                {t.name}
              </option>
            ))}
          </select>
          {error["temperatureUnit"] &&
            <div className="auth_fill_row_error">
              {getLabel(component, error["temperatureUnit"])}
            </div>
          }
        </div>
        <div className="auth_fill_footer">
          <input
            type="button"
            className="page_button auth_cont_login_button"
            value={getLabel(component, "Submit")}
            onClick={onClickSubmit}
            disabled={loading}
          />
          <input
            type="button"
            className="page_button auth_cont_cancel_button"
            style={{ backgroundColor: "#424242"}}
            value={getLabel(component, "Cancel")}
            onClick={onClickCancel}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );

};

export default AuthFill;